import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Match } from '../types';
import { LikesYouSection } from './LikesYouSection';
import { TopPicks } from './TopPicks';
import { MOCK_PROFILES } from '../data/mockData';
interface MatchesViewProps {
  matches: Match[];
  onSelectMatch: (match: Match) => void;
}
export function MatchesView({
  matches,
  onSelectMatch
}: MatchesViewProps) {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <div className="h-full overflow-y-auto pb-24 bg-zinc-50" data-id="element-241">
      <div className="p-4" data-id="element-242">
        <LikesYouSection data-id="element-243" />
        <TopPicks profiles={MOCK_PROFILES} data-id="element-244" />

        <h2 className="text-lg font-bold text-zinc-900 mb-4 px-2" data-id="element-245">
          New Matches
        </h2>

        {matches.length === 0 ? <div className="text-center py-12" data-id="element-246">
            <p className="text-zinc-500" data-id="element-247">No matches yet. Keep swiping!</p>
          </div> : <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-2 gap-3" data-id="element-248">
            {matches.map(match => <motion.button key={match.id} variants={item} onClick={() => onSelectMatch(match)} className="relative group aspect-[3/4] rounded-xl overflow-hidden shadow-sm" data-id="element-249">
                <img src={match.user.photos[0]} alt={match.user.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-250" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-251" />

                <div className="absolute bottom-2 left-2 text-left" data-id="element-252">
                  <p className="text-white font-bold text-sm" data-id="element-253">
                    {match.user.name}, {match.user.age}
                  </p>
                  {match.hasUnread && <span className="inline-block w-2 h-2 bg-rose-500 rounded-full mb-1" data-id="element-254" />}
                </div>

                {match.user.online && <div className="absolute top-2 right-2 w-2.5 h-2.5 bg-green-500 rounded-full border border-white shadow-sm" data-id="element-255" />}
              </motion.button>)}
          </motion.div>}
      </div>
    </div>;
}